import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPrice(price: number | string): string {
  if (price === 'Call' || price === 0 || price === '0') return 'Price on Request'
  const num = typeof price === 'string' ? parseFloat(price.replace(/,/g, '')) : price
  if (isNaN(num)) return String(price)
  if (num >= 10000000) return `₹ ${(num / 10000000).toFixed(2)} Cr`
  if (num >= 100000) return `₹ ${(num / 100000).toFixed(2)} Lac`
  return `₹ ${num.toLocaleString('en-IN')}`
}

/** Compact price label for listing cards — e.g. ₹53 L, ₹2.1 Cr */
export function formatPriceCompact(price: number | string): string {
  if (price === 'Call' || price === 0 || price === '0') return 'Price on Request'
  const num = typeof price === 'string' ? parseFloat(price.replace(/,/g, '')) : price
  if (isNaN(num)) return String(price)
  if (num >= 10000000) {
    const cr = num / 10000000
    return `₹${cr % 1 === 0 ? cr.toFixed(0) : cr.toFixed(2)} Cr`
  }
  if (num >= 100000) {
    const lac = num / 100000
    return `₹${lac % 1 === 0 ? lac.toFixed(0) : lac.toFixed(2)} L`
  }
  return `₹${num.toLocaleString('en-IN')}`
}

export function formatPriceRange(min: number | string, max?: number | string): string {
  if (!max || min === max) return formatPriceCompact(min)
  return `${formatPriceCompact(min)} - ${formatPriceCompact(max).replace('₹', '').trim()}`
}

export function formatRelativeDate(date: string): string {
  const diff = Date.now() - new Date(date).getTime()
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  if (days === 0) return 'Posted today'
  if (days === 1) return 'Posted yesterday'
  if (days < 30) return `Posted ${days} days ago`
  const months = Math.floor(days / 30)
  return `Posted ${months} month${months > 1 ? 's' : ''} ago`
}
